import { lazy } from 'react';

import { withSuspense, isMobile } from 'utils';

const importCb = () => (isMobile() ? import('./LayoutMobile') : import('./LayoutDesktop'));

export default withSuspense(lazy(importCb));
